import { Component, Input, OnInit,EventEmitter,Output,Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonService } from '../services/common.service';
import { W700servicesService } from '../services/w700services.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

declare var $;
@Component({
  selector: 'app-jobproperties',
  templateUrl: './jobproperties.component.html',
  styleUrls: ['./jobproperties.component.scss'] 
})
export class JobpropertiesComponent implements OnInit {

  @Input() inputDataInModalComponent: any;
  @Output() jobPropertiesContent = new EventEmitter<string>();
  @Output() savePropertiesEvent = new EventEmitter<string>();
  screenHeight: number;
  propertyForm: FormGroup;
  

  constructor(private activeModal: NgbActiveModal,    private toastr: ToastrService,
    private w700service: W700servicesService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private w700servicesService: W700servicesService,
    private router: Router,
    private service: CommonService,
    private renderer: Renderer2,
    private fb: FormBuilder,
  ) { this.propertyForm = this.fb.group({
    ownerId: [{ value: '', disabled: true }, Validators.required], 
    ownerType: ['', Validators.required],
    prefixType: ['', Validators.required],
    propertyKey: ['', Validators.required],
    propertyValue: ['', Validators.required]
  }); }  
  Name: string = '';
  deploymentkey: string = '';
  keywordsearchoperation: string = 'PropertyKey';
  JobName: string = '';
  JobId: number = 0;
  pagerolepermisions: any = [];
  Operationname: string = '';
  retrievedPropertyKeys: string[] = [];
  keywordsearchPropertyKey: string = '';
  isLoadingpro: boolean = false;
  notfounddata: boolean = false;
  isOldJob:boolean;
  itemTemplatepro
  notFoundTemplatepro: boolean = false;
 
  async ngOnInit() {
    this.screenHeight  = window.innerHeight -163
    if (await this.service.checksession() == true) {
      const menuid = JSON.parse(sessionStorage.getItem('rolewithmenus')).find(x => x.RoleName == sessionStorage.getItem('SelectedUserRole')).menuslist.find(y => y.MenuName == 'w700').MenuId;
      const actionitems = JSON.parse(sessionStorage.getItem('rolewithmenus')).find(x => x.RoleName == sessionStorage.getItem('SelectedUserRole')).menuslist.filter(y => y.ParentMenuId == menuid);
      actionitems.forEach(element => {
        this.pagerolepermisions[element.MenuName] = true;
      });
      if (this.pagerolepermisions != undefined) {
        this.JobId = this.inputDataInModalComponent.dataitem.JobId;
        this.JobName = this.inputDataInModalComponent.dataitem.JobName;
        this.deploymentkey = this.inputDataInModalComponent.deploymentkey;
        this.Name = this.inputDataInModalComponent.dataitem.Name;
        this.Operationname = this.inputDataInModalComponent.dataitem.OperationValue;
        if(this.inputDataInModalComponent.newJob)
        {
          $("#newPopupModal").appendTo("body").modal({backdrop: 'static', keyboard: false},"show");
        }
        else
        { 
          await this.getjobproperties(this.JobId);
        }
        this.propertyForm.patchValue({ ownerId: this.JobId });
       
      }
    }    
  }


  closetpopup() {
    this.activeModal.close();
  }

  jobpropertieslist: any = [];
  async getjobproperties(jobid) {

    var apiname = "api/VitalHubDXAPI/GetW700Properties?jobid=" + jobid ;
    this.ngxUiLoaderService.start();
    this.w700service.getapi(apiname,this.deploymentkey).subscribe({
      next: data => {
        const arraydata = data as any[];
        const resw700OperProperties = data["w700jobPropertieslist"];
        if (resw700OperProperties == null) {
          this.toastr.warning('Properties are not mapped to the operation: ' + this.Operationname, "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
          this.jobPropertiesContent.emit(this.JobName);
          this.activeModal.close();
          //this.activeModal.close();
          // this.displaymessageclass = "btn alert-warning "
          // this.displaymessage = ;
          // this.FadeOutmainpageMsg();
        }
        else {
          const resw700jobPropertieslist = data["w700jobPropertieslist"];
          if (resw700jobPropertieslist && resw700jobPropertieslist.length > 0) {
              resw700jobPropertieslist.forEach(element => {
                let obj={}
                obj['PropertyKey']= element["PropertyKey"];
                obj['PropertyValue'] = element["PropertyValue"];
                obj['PropertyId']= element["PropertyId"];
                obj['PrefixType'] = element["PrefixType"];
                obj['OwnerType'] = element["OwnerType"];
                this.jobpropertieslist.push(obj);
              });
              this.isOldJob = true;
             // $("#displayPropertiesModal").appendTo("body").modal('show');
          }
          else {
            this.toastr.warning('Properties are not mapped to the operation: ' + this.Operationname, "", { timeOut: 4000, positionClass: 'toast-bottom-right' });       
            this.jobPropertiesContent.emit(this.JobName);
            this.activeModal.close();
          }         
        }
        //this.activeModal.close();
        this.ngxUiLoaderService.stop();
      },
      error: error => {
        this.ngxUiLoaderService.stop();
        this.toastr.warning('Job Properties Not Found', "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
      }
    });

  }


  async getlabeldisplaytext(datajson) {

    return JSON.parse(datajson.lookupId)["displayname"];

  }

  savew700jobproperties: any = [];
  async SaveJobProperties(closeAfterSave: boolean = false) {
    var returnvalue = await this.validationchecks();
    if (returnvalue == true) {

      this.jobpropertieslist.forEach(element => {
        this.savew700jobproperties.push(
          {
            PropertyId: element.PropertyId,
            OwnerId: this.JobId,
            OwnerType: element.OwnerType,
            PrefixType: element.PrefixType,
            PropertyKey: element.PropertyKey,
            PropertyValue: element.PropertyValue
          });
      });

      const savejobprop = {
        "w700jobPropertieslist": this.savew700jobproperties,
        "DeploymentKey": this.deploymentkey,
        "LastUpdatedBy": JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid']    
      };

      this.ngxUiLoaderService.start();    
      var responseroutedata = await this.w700service.postapi('api/VitalHubDXAPI/SaveW700JobsProperties', savejobprop,this.deploymentkey);
      if (responseroutedata['status'].toLowerCase() === 'failure') {
        this.ngxUiLoaderService.stop();
        this.service.copyableToastError('Failed to save job properties ' + responseroutedata['statusmessage']);
        // this.displaymessageclass = "btn alert-danger "
        // this.displaymessage = 'Failure to save job properties ' + responseroutedata['statusText'];
        // this.FadeOutmainpageMsg();
      }
      else {
        this.toastr.success(  "Job properties saved successfully ", "", { timeOut: 500, positionClass: 'toast-bottom-right' });
        if (closeAfterSave) {
          this.closetpopup();
        }
      }
      this.ngxUiLoaderService.stop();
    }
    else {
      // this.FadeOutmainpageMsg();
    }
  }


  displaymessageclass: string = '';
  displaymessageflag = false;
  displaymessage: string = '';

  async validationchecks() {
    let flag = true;
    for (let index = 0; index < this.jobpropertieslist.length; index++) {
      const element = this.jobpropertieslist[index];
      if (element.mandatory &&
        (element.propertykey === 'entity type' ||
         element.propertykey === 'process after' ||
         element.propertykey === 'check on hold' ||
         element.propertykey === 'Supported Files' ||
         element.propertykey === 'Database') &&
        element.propertyvalue === "") {
      this.service.copyableToastError('Please enter ' + element.propertykey);
          // this.displaymessageclass = "btn alert-danger "
          // this.displaymessage = 'Please enter ' + element.displayname;
          flag = false;
          break;
        }
        else if (element.datatype === 'Integer') {
          let val = element.propertyvalue.replace(/[^0-9+#]/g, "");
          if (val.length === 0) {
            this.service.copyableToastError('Please enter ' + element.datatype + ' only for ' + element.displayname);

              // this.displaymessageclass = "btn alert-danger "
              // this.displaymessage = 'Please enter ' + element.datatype + ' only on ' + element.displayname;
              flag = false;
              break;
            }
          }
          // else if (element.datatype == 'String') {
          //   let val = element.propertyvalue;
          //   val = val.replace(/[^0-9+#]/g, "");
          //   if (val.length !== 0) {
          //     this.displaymessageclass = "btn alert-danger "
          //     this.displaymessage = 'Please enter valid ' + element.datatype + 'value on ' + element.displayname;
          //     flag = false;
          //     break;
          //   }
          // }
        }
        return flag;
      }
    
    // this.jobpropertieslist.forEach(element => {
    //   if (element.mandatory) {
    //     if (element.propertyvalue == '') {
    //       this.displaymessageclass = "btn alert-danger "
    //       this.displaymessage = 'Please Enter' + element.displayname;
    //       return false;
    //     }
    //   }
    // });
    // return true;

  FadeOutmainpageMsg() {
    this.displaymessageflag = true;
    setTimeout(() => {
      this.displaymessageflag = false;
    }, 20000);
  }

  autoclosetemplate() {
    setTimeout(() => {
      this.activeModal.close();
    }, 3000);
  }
  async getDistinctPropertyKey(PropertyKey: any) {
    this.isLoadingpro = true;
    var apiname = "api/VitalHubDXAPI/GetDistinctPropertyKey?PropertyKey=" + PropertyKey;
    //this.ngxUiLoaderService.start();

    this.w700service.getapi(apiname, this.deploymentkey).subscribe({
        next: data => {
          if (data.length > 0) {
            this.retrievedPropertyKeys = data.map(item => item.PropertyKey);
           } else {
            this.toastr.warning('w700Job Property Not Found ', "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
        }
           // this.ngxUiLoaderService.stop();
           this.isLoadingpro = false;
        },
        error: error => {
           // this.ngxUiLoaderService.stop();
            this.toastr.warning('w700Job Properties Not Found', "", { timeOut: 4000, positionClass: 'toast-bottom-right' });
            this.isLoadingpro = false;
          }
    });
}

searchPropertyKeyCleared(event) {
  this.isLoadingpro = false;
  this.retrievedPropertyKeys = [];
  this.notfounddata=false;
}
modalhide()
{
  //$("#newPopupModal").modal("hide");
  this.inputDataInModalComponent.newJob = false;
  setTimeout(() => {

    const modalElement = document.getElementById('newPopupModal');
    if (modalElement) {
      this.renderer.removeClass(modalElement, 'show');
      this.renderer.setStyle(modalElement, 'display', 'none');
    }

    const modalBackdrops = document.getElementsByClassName('custom-modal');
    while (modalBackdrops.length) {
      this.renderer.removeChild(modalBackdrops[0].parentNode, modalBackdrops[0]);
    }

    this.renderer.removeClass(document.body, 'modal-open');
  }, 0); 
}

modalclose()
{
$("#newPopupModal").modal("hide");
}      
savejobpropertieslist: any[] = [];
async SaveProperties() {

    this.savejobpropertieslist.push({
      OwnerId: this.JobId,
      OwnerType: this.propertyForm.value.ownerType,
      PrefixType: this.propertyForm.value.prefixType,
      PropertyKey: this.propertyForm.value.propertyKey,
      PropertyValue: this.propertyForm.value.propertyValue
    });

    const savejobprop = {
      "w700jobPropertieslist": this.savejobpropertieslist,
      "DeploymentKey": this.deploymentkey,
      "LastUpdatedBy": JSON.parse(sessionStorage.getItem('sessionObjectlogin')).userdata['userid']    
    };

    this.ngxUiLoaderService.start();    
    var responseroutedata = await this.w700service.postapi('api/VitalHubDXAPI/SaveW700JobsProperties', savejobprop,this.deploymentkey);
    if (responseroutedata['status'].toLowerCase() === 'failure') {
      this.ngxUiLoaderService.stop();
      this.service.copyableToastError('Failed to create job properties ' + responseroutedata['statusmessage']);
    }
    else {
      this.toastr.success(  "Job properties created successfully ", "", { timeOut: 500, positionClass: 'toast-bottom-right' });
      this.w700servicesService.savePropertiesEvent.emit(this.JobName);
    }

    this.ngxUiLoaderService.stop();
    this.modalhide();
  }
}




  
